// extracted by mini-css-extract-plugin
export default {"text":"FormatProfileField_text__fqzJq","breakWord":"FormatProfileField_breakWord__gnU-w","expandButton":"FormatProfileField_expandButton__41nUb"};